import { BaseService } from 'core/services';
import { DashboardRouteService } from 'common/data';

class DashboardService extends BaseService {
	constructor(apiClient) {
		super(apiClient, new DashboardRouteService());
	}

	getOrdersSummary = () => {
		const url = this.routeService.ordersSummary();
		return this.apiClient.get(url);
	};

	getCounts = () => {
		const url = this.routeService.counts();
		return this.apiClient.get(url);
	};

	getShipByDate = () => {
		const url = this.routeService.shipByDate();
		return this.apiClient.get(url);
	};

	getOrders = filter => {
		const url = this.routeService.orders(filter);
		return this.apiClient.get(url);
	};

	getCarrierCbm = () => {
		const url = this.routeService.carrierCbm();
		return this.apiClient.get(url);
	};

	getCompletedCount = filter => {
		const url = this.routeService.completedCount(filter);
		return this.apiClient.get(url);
	};

	getStatuses = () => {
		const url = this.routeService.statuses();
		return this.apiClient.get(url);
	};
}

export default DashboardService;
